(function () {
  var MEANING = {
    "Outstanding": "The service is performing exceptionally well.",
    "Good": "The service is performing well and meeting our expectations.",
    "Requires improvement": "The service is not performing as well as it should and we have told the service how it must improve.",
    "Inadequate": "The service is performing badly and we've taken action against the person or organisation that runs it."
  };
  var ICON = {
    "Outstanding": "★",
    "Good": "✓",
    "Requires improvement": "!",
    "Inadequate": "✕"
  };
  var RANK = { "Outstanding": 0, "Good": 1, "Requires improvement": 2, "Inadequate": 3 };
  var PASTEL = ["#D8F3E6", "#FFE3D3", "#DCEBFA", "#E6E3F7", "#FFF3B0"];
  var MILES = 3958.8;
  var state = {
    districts: null,
    agencies: [],
    district: "",
    radius: 10,
    widened: false,
    sort: "rated",
    ratings: { "Outstanding": true, "Good": true, "Requires improvement": true, "Inadequate": true, "Not rated": true },
    types: { "Dementia": false, "Older people": false },
    shown: 0,
    short: [],
    open: {},
    outside: ""
  };

  var input = document.getElementById("postcode");
  var live = document.getElementById("result-count");
  var list = document.getElementById("cards");
  var statusBox = document.getElementById("status");
  var where = document.getElementById("where");
  var tray = document.getElementById("tray");
  var sheet = document.getElementById("sheet");
  var filtersBtn = document.getElementById("filters-btn");

  function base() {
    return document.body.getAttribute("data-cqc-base") || "";
  }

  function dataUrl(name) {
    var key = String(name || "").toLowerCase();
    var map = window.CQC_URLS;
    if (map && map[key]) return map[key];
    return base() + "cqc-data-" + key + ".js";
  }

  function $(id) { return document.getElementById(id); }

  function compact(value) {
    return String(value || "").toUpperCase().replace(/\s+/g, "");
  }

  function districtOf(value) {
    var raw = compact(value);
    if (!raw) return "";
    var full = raw.match(/^([A-Z]{1,2}\d[A-Z\d]?)(\d[A-Z]{2})$/);
    var outward = full ? full[1] : raw;
    return /^[A-Z]{1,2}\d[A-Z\d]?$/.test(outward) ? outward : "";
  }

  function areaOf(district) {
    var match = String(district).match(/^[A-Z]{1,2}/);
    return match ? match[0] : "";
  }

  function haversine(aLat, aLng, bLat, bLng) {
    var r1 = aLat * Math.PI / 180;
    var r2 = bLat * Math.PI / 180;
    var dLat = (bLat - aLat) * Math.PI / 180;
    var dLng = (bLng - aLng) * Math.PI / 180;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(r1) * Math.cos(r2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * MILES * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  function milesLabel(miles) {
    if (miles < 2) {
      var tenths = Math.round(miles * 10) / 10;
      if (tenths < 0.1) tenths = 0.1;
      var shown = tenths.toFixed(1).replace(/\.0$/, "");
      return "about " + shown + " mile" + (Number(shown) === 1 ? "" : "s");
    }
    var n = Math.round(miles);
    return "about " + n + " miles";
  }

  function parseDate(text) {
    var match = String(text || "").match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!match) return null;
    var date = new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
    if (date.getFullYear() !== Number(match[3])) return null;
    return date;
  }

  function relative(date) {
    var now = new Date();
    var months = (now.getFullYear() - date.getFullYear()) * 12 + (now.getMonth() - date.getMonth());
    if (now.getDate() < date.getDate()) months -= 1;
    if (months < 1) return "less than a month ago";
    if (months < 12) return months + " month" + (months === 1 ? "" : "s") + " ago";
    var years = Math.round(months / 12);
    return "about " + years + " year" + (years === 1 ? "" : "s") + " ago";
  }

  function olderThanThreeYears(date) {
    var cutoff = new Date();
    cutoff.setFullYear(cutoff.getFullYear() - 3);
    return date < cutoff;
  }

  function initials(name) {
    var parts = String(name).replace(/[^A-Za-z0-9 ]/g, " ").trim().split(/\s+/);
    return ((parts[0] || "?").charAt(0) + (parts[1] || "").charAt(0)).toUpperCase();
  }

  function pastel(name) {
    var n = 0;
    for (var i = 0; i < name.length; i++) n = (n + name.charCodeAt(i)) % PASTEL.length;
    return PASTEL[n];
  }

  function formatPhone(raw) {
    var digits = String(raw || "").replace(/\D/g, "");
    if (digits.length === 10) digits = "0" + digits;
    if (digits.length !== 11) return String(raw || "");
    if (digits.indexOf("03") === 0 || digits.indexOf("08") === 0) return digits.slice(0, 4) + " " + digits.slice(4, 7) + " " + digits.slice(7);
    if (digits.indexOf("02") === 0) return digits.slice(0, 3) + " " + digits.slice(3, 7) + " " + digits.slice(7);
    return digits.slice(0, 5) + " " + digits.slice(5);
  }

  function phoneHref(raw) {
    var digits = String(raw || "").replace(/\D/g, "");
    if (digits.length === 10) digits = "0" + digits;
    return digits;
  }

  function pageSize() {
    return window.matchMedia("(max-width: 767px)").matches ? 5 : 10;
  }

  function el(tag, attrs, text) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (key) {
        if (key === "class") node.className = attrs[key];
        else if (key.indexOf("data-") === 0) node.setAttribute(key, attrs[key]);
        else node[key] = attrs[key];
      });
    }
    if (text != null) node.textContent = text;
    return node;
  }

  function icon(path) {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", "22");
    svg.setAttribute("height", "22");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", "#1B2D4F");
    svg.setAttribute("stroke-width", "1.75");
    svg.setAttribute("stroke-linecap", "round");
    svg.setAttribute("stroke-linejoin", "round");
    svg.setAttribute("aria-hidden", "true");
    svg.innerHTML = path;
    return svg;
  }

  function loadJson(url) {
    var root = document.getElementById("cqc-finder");
    var stamp = (root && root.getAttribute("data-cqc-date")) || document.body.getAttribute("data-cqc-date") || "";
    var fresh = url + (url.indexOf("?") === -1 ? "?v=" : "&v=") + encodeURIComponent(stamp);
    return fetch(fresh, { credentials: "omit" }).then(function (response) {
      if (!response.ok) throw new Error("missing");
      return response.text();
    }).then(function (text) {
      var start = text.indexOf("{");
      if (start < 0) throw new Error("missing");
      return JSON.parse(text.slice(start));
    });
  }

  function ensureDistricts() {
    if (state.districts) return Promise.resolve(state.districts);
    return loadJson(dataUrl("districts")).then(function (data) {
      state.districts = data.d || {};
      return state.districts;
    });
  }

  function areasNear(district) {
    var origin = state.districts[district];
    var areas = {};
    areas[areaOf(district)] = true;
    Object.keys(state.districts).forEach(function (key) {
      var row = state.districts[key];
      if (row[2] !== "E") return;
      if (haversine(origin[0], origin[1], row[0], row[1]) <= 40) areas[areaOf(key)] = true;
    });
    return Object.keys(areas).filter(function (area) { return /^[A-Z]{1,2}$/.test(area); });
  }

  function stale(iso) {
    if (!iso) return false;
    var then = new Date(iso + "T00:00:00");
    return (Date.now() - then.getTime()) / 86400000 > 45;
  }

  function markFreshness(iso, label) {
    var pill = $("fresh");
    if (!pill) return;
    var old = stale(iso);
    pill.classList.toggle("is-stale", old);
    pill.innerHTML = "";
    pill.appendChild(el("i", { className: "dot" }));
    pill.appendChild(document.createTextNode(old
      ? " This list may be out of date – check the CQC website"
      : " CQC data updated " + (label || "")));
  }

  function setStatus(kind, title, body) {
    statusBox.hidden = false;
    statusBox.className = kind;
    statusBox.innerHTML = "";
    if (kind === "empty") {
      statusBox.appendChild(lineArt());
    }
    statusBox.appendChild(el("h3", null, title));
    if (body) statusBox.appendChild(el("p", null, body));
    if (kind === "outside") outsideLinks(statusBox);
    if (kind === "empty") {
      var again = el("button", { className: "btn btn-navy", type: "button" }, "Try another postcode");
      again.addEventListener("click", function () { input.focus(); });
      statusBox.appendChild(again);
    }
  }

  function lineArt() {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 120 70");
    svg.setAttribute("height", "70");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", "#1B2D4F");
    svg.setAttribute("stroke-width", "2.2");
    svg.setAttribute("aria-hidden", "true");
    svg.innerHTML = '<circle cx="50" cy="30" r="18"/><path d="M63 43l20 20"/><path d="M44 30h12"/>';
    return svg;
  }

  function outsideLinks(box) {
    var links = [
      ["Wales: Care Inspectorate Wales", "https://www.careinspectorate.wales/"],
      ["Scotland: Care Inspectorate", "https://www.careinspectorate.scot/"],
      ["Northern Ireland: RQIA", "https://www.rqia.org.uk/"]
    ];
    links.forEach(function (item) {
      var a = el("a", { className: "btn btn-line", href: item[1], target: "_blank", rel: "noopener noreferrer" }, item[0]);
      box.appendChild(a);
    });
    box.appendChild(el("p", null, "Check with your council about free personal care (https://www.mygov.scot/personal-nursing-care)"));
    box.appendChild(el("p", null, "Check with your local Health and Social Care (HSC) Trust about home help charges (https://www.nidirect.gov.uk/articles/arranging-health-and-social-care)"));
  }

  function skeletons() {
    list.innerHTML = "";
    for (var i = 0; i < 3; i++) {
      var card = el("div", { className: "skel" });
      card.appendChild(el("i"));
      card.appendChild(el("i"));
      card.appendChild(el("i"));
      list.appendChild(card);
    }
  }

  function filtered() {
    return state.agencies.filter(function (agency) {
      if (agency.miles > state.radius) return false;
      var key = MEANING[agency.rating] ? agency.rating : "Not rated";
      if (!state.ratings[key]) return false;
      if (state.types.Dementia && agency.specialisms.indexOf("Dementia") === -1) return false;
      if (state.types["Older people"] && agency.specialisms.indexOf("Caring for adults over 65 yrs") === -1) return false;
      return true;
    }).sort(function (a, b) {
      if (state.sort === "rated") {
        var ar = RANK[a.rating] == null ? 9 : RANK[a.rating];
        var br = RANK[b.rating] == null ? 9 : RANK[b.rating];
        if (ar !== br) return ar - br;
      }
      return a.miles - b.miles;
    });
  }

  function filterCount() {
    var n = 0;
    var keys = Object.keys(state.ratings);
    if (!keys.every(function (key) { return state.ratings[key]; })) n += 1;
    Object.keys(state.types).forEach(function (key) { if (state.types[key]) n += 1; });
    if (state.radius !== 10) n += 1;
    return n;
  }

  function render() {
    if (!state.district) return;
    var rows = filtered();
    var size = pageSize();
    if (!state.shown) state.shown = size;
    var visible = rows.slice(0, state.shown);
    var nearest = rows.length ? milesLabel(rows.slice().sort(function (a, b) { return a.miles - b.miles; })[0].miles) : "";
    var sentence = rows.length
      ? rows.length + " " + (rows.length === 1 ? "agency" : "agencies") + " within " + state.radius + " miles of " + state.district + ". The nearest is " + nearest + " away."
      : "No results within " + state.radius + " miles";
    if (state.widened) sentence = "No agencies within 10 miles, so we're showing agencies within 25 miles. " + sentence;
    live.textContent = sentence;
    var wt = $("where-text");
    wt.textContent = "";
    wt.appendChild(document.createTextNode("Near "));
    wt.appendChild(el("b", null, state.district));
    wt.appendChild(document.createTextNode(" · " + state.radius + " miles"));
    where.hidden = false;
    list.innerHTML = "";
    statusBox.hidden = true;
    if (!rows.length && state.radius >= 25) {
      setStatus("empty", "No results within 25 miles", "We couldn't find a home care agency within 25 miles of that postcode.");
    } else if (!rows.length) {
      setStatus("empty", "No results within " + state.radius + " miles", "Try a wider distance, or another postcode.");
    }
    visible.forEach(function (agency) { list.appendChild(card(agency)); });
    var more = $("more");
    if (rows.length > visible.length) {
      more.hidden = false;
      more.textContent = "Show " + size + " more";
    } else {
      more.hidden = true;
    }
    var toggle = $("sort-toggle");
    if (toggle) toggle.textContent = state.sort === "near" ? "Nearest" : "Best rated";
    $("filters-count").textContent = String(filterCount());
    var showN = $("show-n");
    if (showN) showN.textContent = "Show " + rows.length + (rows.length === 1 ? " agency" : " agencies");
    renderTray();
    document.body.classList.add("has-bar");
  }

  function card(agency) {
    var article = el("article", { className: "card", id: "agency-" + agency.id });
    article.tabIndex = -1;
    var body = el("div", { className: "card-body" });
    var tile = el("div", { className: "initials" }, initials(agency.name));
    tile.style.background = pastel(agency.name);
    var main = el("div", { className: "card-main" });
    var top = el("div", { className: "card-top" });
    top.appendChild(el("h3", null, agency.name));
    var on = state.short.indexOf(agency.id) !== -1;
    var short = el("button", { className: on ? "sl on" : "sl", type: "button" }, on ? "✓ Shortlisted" : "＋ Shortlist");
    short.setAttribute("aria-pressed", on ? "true" : "false");
    short.addEventListener("click", function () { toggleShort(agency.id); });
    top.appendChild(short);
    main.appendChild(top);
    var word = agency.rating;
    var date = parseDate(agency.ratingDate);
    if (word) {
      var badge = el("div", { className: "badge" });
      badge.appendChild(el("i", null, ICON[word] || "–"));
      var words = el("span", { className: "badge-words" });
      words.appendChild(el("b", null, word));
      words.appendChild(el("small", null, "CQC rating"));
      badge.appendChild(words);
      main.appendChild(badge);
      if (MEANING[word]) {
        var mean = el("p", { className: "meaning" });
        mean.appendChild(el("em", null, MEANING[word]));
        mean.appendChild(document.createTextNode(" "));
        mean.appendChild(el("span", null, "– CQC"));
        main.appendChild(mean);
      }
    } else {
      main.appendChild(el("p", { className: "norate" }, "No overall rating in CQC's file"));
    }
    var facts = el("div", { className: "facts" });
    facts.appendChild(fact(agency.town + " · " + milesLabel(agency.miles) + " away", "pin"));
    facts.appendChild(fact(careType(agency), "care"));
    var inspected = el("div");
    inspected.appendChild(icon('<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>'));
    var when = el("span");
    when.appendChild(document.createTextNode("Last inspected "));
    when.appendChild(el("b", null, agency.ratingDate || "date not in CQC's file"));
    if (date) when.appendChild(el("small", null, relative(date)));
    inspected.appendChild(when);
    facts.appendChild(inspected);
    facts.appendChild(fact(agency.specialisms.join(" · ") || "Specialisms not listed", "list"));
    main.appendChild(facts);
    if (date && olderThanThreeYears(date)) {
      main.appendChild(el("div", { className: "old" }, "Last inspected more than 3 years ago"));
    }
    var scores = scoreRow(agency);
    if (scores) {
      var details = document.createElement("details");
      details.className = "more-info";
      var summary = document.createElement("summary");
      var label = el("span", { className: "more-label" }, "Show the five CQC scores");
      summary.appendChild(label);
      summary.appendChild(el("span", { className: "more-hint" }, "Safe, Effective, Caring, Responsive and Well-led"));
      details.appendChild(summary);
      details.appendChild(scores);
      details.addEventListener("toggle", function () {
        label.textContent = details.open ? "Hide the five CQC scores" : "Show the five CQC scores";
      });
      main.appendChild(details);
    } else if (word) {
      main.appendChild(el("p", { className: "miles-line" }, "CQC has not published the five scores for this agency."));
    }
    body.appendChild(tile);
    body.appendChild(main);
    article.appendChild(body);
    article.appendChild(footer(agency));
    return article;
  }

  var SCORE_NAMES = ["Safe", "Effective", "Caring", "Responsive", "Well-led"];

  function scoreRow(agency) {
    if (!agency.scores || !agency.scores.some(Boolean)) return null;
    var wrap = el("div", { className: "scores" });
    wrap.appendChild(el("p", { className: "scores-cap" }, "CQC key questions"));
    var list = document.createElement("dl");
    SCORE_NAMES.forEach(function (name, i) {
      if (!agency.scores[i]) return;
      var row = document.createElement("div");
      row.appendChild(el("dt", null, name));
      row.appendChild(el("dd", null, agency.scores[i]));
      list.appendChild(row);
    });
    wrap.appendChild(list);
    return wrap;
  }

  function fact(text) {
    var node = el("div");
    node.appendChild(icon('<path d="M12 21s-7-6.5-7-12a7 7 0 0114 0c0 5.5-7 12-7 12z"/><circle cx="12" cy="9" r="2.5"/>'));
    node.appendChild(el("span", null, text));
    return node;
  }

  function careType(agency) {
    var extra = agency.extra && agency.extra.length ? " · " + agency.extra.join(" · ") : "";
    return "Help at home (domiciliary care)" + extra;
  }

  function footer(agency) {
    var foot = el("div", { className: "card-foot" });
    if (agency.phone) {
      var pretty = formatPhone(agency.phone);
      var call = el("a", { className: "btn btn-yellow", href: "tel:" + phoneHref(agency.phone) });
      call.setAttribute("aria-label", "Call " + pretty);
      call.appendChild(icon('<path d="M6 4h3l2 5-2 1a12 12 0 006 6l1-2 5 2v3a2 2 0 01-2 2A16 16 0 014 6a2 2 0 012-2z"/>'));
      call.appendChild(el("span", { className: "call-long" }, "Call " + pretty));
      call.appendChild(el("span", { className: "call-short" }, "Call"));
      foot.appendChild(call);
    } else {
      var none = el("span", { className: "btn no-phone", title: "CQC has not published a phone number for this agency" });
      none.setAttribute("aria-label", "CQC has not published a phone number for this agency");
      none.appendChild(el("span", { className: "call-long" }, "No number listed"));
      none.appendChild(el("span", { className: "call-short" }, "No number"));
      foot.appendChild(none);
    }
    var report = el("a", {
      className: "btn btn-navy",
      href: "https://www.cqc.org.uk/location/" + agency.id,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "See CQC report");
    report.setAttribute("aria-label", "See the CQC report");
    foot.appendChild(report);
    foot.appendChild(mapsLink(agency));
    return foot;
  }

  function mapsLink(agency) {
    var query = encodeURIComponent(agency.name + ", " + agency.town + ", " + agency.postcode);
    var maps = el("a", {
      className: "maps",
      href: "https://www.google.com/maps/search/?api=1&query=" + query,
      target: "_blank",
      rel: "noopener noreferrer"
    });
    maps.appendChild(el("span", { className: "maps-long" }, "Open in maps ↗"));
    maps.appendChild(el("span", { className: "maps-short" }, "Maps ↗"));
    maps.setAttribute("aria-label", "Open in Google Maps");
    return maps;
  }

  function toggleShort(id) {
    var at = state.short.indexOf(id);
    if (at === -1) state.short.push(id);
    else state.short.splice(at, 1);
    render();
  }

  function renderTray() {
    var names = state.short.map(function (id) {
      var found = state.agencies.filter(function (agency) { return agency.id === id; })[0];
      return found ? found.name : "";
    }).filter(Boolean);
    var note = $("short-note");
    if (note) note.hidden = !names.length;
    if (!names.length) {
      tray.hidden = true;
      $("tray-pill").hidden = true;
      return;
    }
    tray.hidden = false;
    $("tray-names").textContent = names.join(" · ");
    $("tray-count").textContent = "Your shortlist (" + names.length + ")";
    var printed = $("print-list");
    if (printed) printed.textContent = names.length ? "Shortlist: " + names.join(" · ") : "";
    var pill = $("tray-pill");
    pill.hidden = false;
    pill.textContent = "♥ Shortlist (" + names.length + ") ▴";
  }

  function search() {
    var raw = input.value;
    var district = districtOf(raw);
    var section = $("results");
    if (section) {
      section.hidden = false;
      scrollToResults();
    }
    statusBox.hidden = true;
    list.innerHTML = "";
    if (compact(raw).indexOf("BT") === 0) {
      where.hidden = true;
      setStatus("outside", "Not in England?", "This finder covers England. Home care is checked by a different body where you live.");
      return;
    }
    if (!district) {
      where.hidden = true;
      setStatus("unknown", "We couldn't find that postcode. Check it and try again, or try just the first half, like NR1.", "");
      return;
    }
    skeletons();
    ensureDistricts().then(function () {
      var row = state.districts[district];
      if (!row) {
        where.hidden = true;
        list.innerHTML = "";
        setStatus("unknown", "We couldn't find that postcode. Check it and try again, or try just the first half, like NR1.", "");
        return;
      }
      if (row[2] === "S" || row[2] === "W") {
        where.hidden = true;
        list.innerHTML = "";
        setStatus("outside", "Not in England?", "This finder covers England. Home care is checked by a different body where you live.");
        return;
      }
      if (row[2] !== "E") {
        where.hidden = true;
        list.innerHTML = "";
        setStatus("unknown", "We couldn't find that postcode. Check it and try again, or try just the first half, like NR1.", "");
        return;
      }
      var areas = areasNear(district);
      return Promise.all(areas.map(function (area) {
        return loadJson(dataUrl(area)).catch(function () { return { a: [] }; });
      })).then(function (files) {
        var agencies = [];
        var label = "";
        var iso = "";
        files.forEach(function (file) {
          label = file.dataDateLabel || label;
          iso = file.dataDate || iso;
          (file.a || []).forEach(function (item) {
            var miles = haversine(row[0], row[1], item[8], item[9]);
            if (miles > 25) return;
            agencies.push({
              id: item[0], name: item[1], town: item[2], postcode: item[3], phone: item[4],
              specialisms: item[5] || [], rating: item[6] || "", ratingDate: item[7] || "",
              miles: miles, scores: Array.isArray(item[10]) && item[10].length === 5 ? item[10] : [],
              extra: item[11] || []
            });
          });
        });
        state.agencies = agencies;
        state.district = district;
        state.shown = pageSize();
        state.short = [];
        state.open = {};
        state.sort = "rated";
        var within10 = agencies.some(function (agency) { return agency.miles <= 10; });
        state.widened = !within10;
        state.radius = within10 ? 10 : 25;
        syncPills();
        markFreshness(iso, label);
        render();
      });
    }).catch(function () {
      list.innerHTML = "";
      setStatus("unknown", "We couldn't load the list. Check your connection and try again.", "");
    });
  }

  function scrollToResults() {
    var target = $("results");
    if (!target) return;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    });
  }

  function syncPills() {
    var keys = Object.keys(state.ratings);
    var allOn = keys.every(function (name) { return state.ratings[name]; });
    document.querySelectorAll("[data-rating]").forEach(function (button) {
      var key = button.getAttribute("data-rating");
      var pressed;
      if (key === "all") pressed = allOn;
      else if (button.closest("#rating-quick")) pressed = !allOn && !!state.ratings[key];
      else pressed = !!state.ratings[key];
      button.setAttribute("aria-pressed", pressed ? "true" : "false");
    });
    document.querySelectorAll("[data-miles]").forEach(function (button) {
      button.setAttribute("aria-pressed", Number(button.getAttribute("data-miles")) === state.radius ? "true" : "false");
    });
    document.querySelectorAll("[data-type]").forEach(function (button) {
      button.setAttribute("aria-pressed", state.types[button.getAttribute("data-type")] ? "true" : "false");
    });
    document.querySelectorAll("[data-sort]").forEach(function (button) {
      button.setAttribute("aria-pressed", button.getAttribute("data-sort") === state.sort ? "true" : "false");
    });
  }

  function bindPills(root) {
    root.addEventListener("click", function (event) {
      var button = event.target.closest("button");
      if (!button) return;
      if (button.hasAttribute("data-rating")) {
        var key = button.getAttribute("data-rating");
        var keys = Object.keys(state.ratings);
        if (key === "all") {
          keys.forEach(function (name) { state.ratings[name] = true; });
        } else {
          var allOn = keys.every(function (name) { return state.ratings[name]; });
          if (allOn) {
            keys.forEach(function (name) { state.ratings[name] = name === key; });
          } else {
            state.ratings[key] = !state.ratings[key];
            if (!keys.some(function (name) { return state.ratings[name]; })) {
              keys.forEach(function (name) { state.ratings[name] = true; });
            }
          }
        }
        state.shown = pageSize();
        syncPills();
        render();
      }
      if (button.hasAttribute("data-miles")) {
        state.radius = Number(button.getAttribute("data-miles"));
        state.widened = false;
        state.shown = pageSize();
        syncPills();
        render();
      }
      if (button.hasAttribute("data-type")) {
        var type = button.getAttribute("data-type");
        state.types[type] = !state.types[type];
        state.shown = pageSize();
        syncPills();
        render();
      }
      if (button.hasAttribute("data-sort")) {
        state.sort = button.getAttribute("data-sort");
        syncPills();
        render();
      }
    });
  }

  function openSheet(open) {
    sheet.hidden = !open;
    filtersBtn.setAttribute("aria-expanded", open ? "true" : "false");
    if (!open) filtersBtn.focus();
  }

  function compare() {
    var chosen = state.short.slice(0, 3).map(function (id) {
      return state.agencies.filter(function (agency) { return agency.id === id; })[0];
    }).filter(Boolean);
    var box = $("compare");
    box.hidden = false;
    box.innerHTML = "";
    if (state.short.length > 3) box.appendChild(el("p", null, "Showing the first 3 on your shortlist."));
    var table = document.createElement("table");
    table.className = "compare";
    var head = document.createElement("tr");
    head.appendChild(el("th", null, ""));
    chosen.forEach(function (agency) { head.appendChild(el("th", null, agency.name)); });
    table.appendChild(head);
    ["CQC rating", "Last inspected", "Town", "Distance"].forEach(function (label, index) {
      var tr = document.createElement("tr");
      tr.appendChild(el("th", null, label));
      chosen.forEach(function (agency) {
        var value = [agency.rating || "No overall rating in CQC's file", agency.ratingDate || "date not in CQC's file", agency.town, milesLabel(agency.miles) + " away"][index];
        tr.appendChild(el("td", null, value));
      });
      table.appendChild(tr);
    });
    box.appendChild(table);
    box.scrollIntoView();
  }

  function printList() {
    window.print();
  }

  document.getElementById("find").addEventListener("click", search);
  input.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      search();
    }
  });
  $("change").addEventListener("click", function () {
    input.focus();
    input.scrollIntoView();
  });
  $("more").addEventListener("click", function () {
    var before = state.shown;
    state.shown += pageSize();
    render();
    var rows = filtered();
    var next = rows[before];
    if (next) {
      var node = document.getElementById("agency-" + next.id);
      if (node) node.focus();
    }
  });
  $("clear").addEventListener("click", clearFilters);
  $("clear-sheet").addEventListener("click", clearFilters);
  function clearFilters() {
    Object.keys(state.ratings).forEach(function (key) { state.ratings[key] = true; });
    Object.keys(state.types).forEach(function (key) { state.types[key] = false; });
    state.radius = state.widened ? 25 : 10;
    state.shown = pageSize();
    syncPills();
    if (state.district) render();
  }
  filtersBtn.addEventListener("click", function () { openSheet(sheet.hidden); });
  $("sheet-close").addEventListener("click", function () { openSheet(false); });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !sheet.hidden) openSheet(false);
  });
  $("show-n").addEventListener("click", function () { openSheet(false); });
  $("tray-pill").addEventListener("click", function () {
    tray.classList.toggle("open");
  });
  $("compare-btn").addEventListener("click", compare);
  $("print-btn").addEventListener("click", printList);
  $("sort-toggle").addEventListener("click", function () {
    state.sort = state.sort === "near" ? "rated" : "near";
    $("sort-toggle").textContent = state.sort === "near" ? "Nearest" : "Best rated";
    syncPills();
    render();
  });
  var menu = $("menu");
  if (menu) menu.addEventListener("click", function () {
    var nav = $("nav");
    var open = nav.classList.toggle("open");
    menu.setAttribute("aria-expanded", open ? "true" : "false");
  });
  bindPills(document);
  function syncAccordions() {
    var desktop = window.matchMedia("(min-width: 768px)");
    function apply() {
      var open = desktop.matches;
      document.querySelectorAll("#cqc-finder details.acc").forEach(function (item) {
        if (item.id === "cqc-costs") return;
        if (item.closest(".bento") || item.closest(".faq")) {
          item.open = false;
          return;
        }
        item.open = open;
      });
      var filters = document.getElementById("filters");
      if (filters) filters.setAttribute("aria-hidden", open ? "false" : "true");
    }
    apply();
    if (desktop.addEventListener) desktop.addEventListener("change", apply);
  }
  syncAccordions();
  var iso = document.body.getAttribute("data-cqc-date");
  if (iso && stale(iso)) markFreshness(iso, document.querySelector(".cqc-data-label").textContent);
})();
